module.exports = __webpack_public_path__ + "media/images/wines/tempranillo/bottle-detail-ec78480f885b10a4b360568cb695073d.png";